import { useState } from "react";
import { Link } from "react-router-dom";
import SalidasTable from "./SalidasTable";
import ReporteMensualTesoreria from "./ReporteMensualTesoreria";

const PESTANAS = [
  { id: "salidas", etiqueta: "Salidas" },
  { id: "reporte", etiqueta: "Reporte mensual" },
];

function PestanasTesoreria({ activa, onCambiar }) {
  return (
    <div className="flex gap-1 border-b border-slate-200 mb-5">
      {PESTANAS.map((p) => (
        <button
          key={p.id}
          type="button"
          onClick={() => onCambiar(p.id)}
          className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px transition ${
            activa === p.id
              ? "border-indigo-600 text-indigo-700"
              : "border-transparent text-slate-500 hover:text-slate-800"
          }`}
        >
          {p.etiqueta}
        </button>
      ))}
    </div>
  );
}

export default function AdminSalidasGeneral() {
  const [pestana, setPestana] = useState("salidas");
  const pestanas = <PestanasTesoreria activa={pestana} onCambiar={setPestana} />;

  if (pestana === "salidas") {
    return <SalidasTable tipo={1} encabezadoExtra={pestanas} />;
  }

  return (
    <div className="p-6 bg-slate-50">
      <div className="text-sm text-slate-400 mb-3">
        <Link to="/dashboard/finanzas" className="hover:text-indigo-600">Finanzas</Link>
        <span className="mx-1.5">/</span>
        <span className="text-slate-600 font-medium">Salidas Tesorería General</span>
      </div>

      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-800">Salidas Tesorería General</h1>
        <p className="text-sm text-slate-500 mt-0.5">Reporte mensual de entradas, salidas y saldo de la tesorería general.</p>
      </div>

      {pestanas}
      <ReporteMensualTesoreria />
    </div>
  );
}
